"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTagsBeyondLimitText = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const searchHook_1 = __importDefault(require("../../utils/searchHook"));
const formatTagsBeyondLimitText = (amount) => `+${amount} more selected`;
exports.formatTagsBeyondLimitText = formatTagsBeyondLimitText;
const AutocompleteCheckboxes = ({ options = [], onChange, getOptionLabel = ({ label }) => label, limitTags = 3, label = "Search", optionsContext, shouldLaunchRequest, onError, search, ...rest }) => {
    const [memorizedSearch, selectableOptions] = (0, searchHook_1.default)(search, options, onError, optionsContext);
    const [inputValue, setInputValue] = (0, react_1.useState)("");
    const onInputChange = (e, value, reason) => {
        if (reason !== "reset") {
            setInputValue(value);
        }
        if (shouldLaunchRequest && reason === "input") {
            memorizedSearch(value);
        }
    };
    return (react_1.default.createElement(material_1.Autocomplete, { ...rest, multiple: true, onChange: onChange, limitTags: limitTags, options: selectableOptions, disableCloseOnSelect: true, getOptionLabel: getOptionLabel, getLimitTagsText: exports.formatTagsBeyondLimitText, noOptionsText: shouldLaunchRequest ? "Search for options" : "No options", inputValue: inputValue, onInputChange: onInputChange, renderInput: (params) => react_1.default.createElement(material_1.TextField, { ...params, label: label }), renderOption: (props, option, { selected }) => (react_1.default.createElement("li", { ...props },
            react_1.default.createElement(material_1.Checkbox, { color: "primary", checked: selected }),
            option.label)) }));
};
exports.default = AutocompleteCheckboxes;
